<template>
  <div class="text-center form-main">
    <p style="line-height:30px;">Ihr optimaler Kurs gemäß<br>Ihrer Berufserfahrung und Ihrer Lernauswahl:</p>
    <p class="text-primary font-weight-bold" style="line-height:30px;">{{courseType}} mit<br>{{courseLevel}}</p>
  </div>
</template>
<script>
export default {
  name: "Confirmation",
  props: {
    courseType: String,
    courseLevel: String,
  },
};
</script>
